const planetData = [
  { 
    name: 'Mercury', 
    size: 0.1, 
    distance: 2, 
    color: '#8C7853', 
    rotationSpeed: 0.02, 
    orbitSpeed: 0.008,
    info: {
      diameter: '4,879 km',
      distanceFromSun: '57.9 million km',
      dayLength: '59 Earth days',
      yearLength: '88 Earth days',
      moons: '0',
      temperature: '427°C (day) / -173°C (night)',
      composition: 'Rocky planet with large iron core'
    }
  },
  { 
    name: 'Venus', 
    size: 0.15, 
    distance: 3, 
    color: '#FFC649', 
    rotationSpeed: 0.015, 
    orbitSpeed: 0.006,
    info: {
      diameter: '12,104 km',
      distanceFromSun: '108.2 million km',
      dayLength: '243 Earth days',
      yearLength: '225 Earth days',
      moons: '0',
      temperature: '462°C (surface)',
      composition: 'Rocky with thick toxic atmosphere'
    }
  },
  { 
    name: 'Earth', 
    size: 0.16, 
    distance: 4, 
    color: '#6B93D6', 
    rotationSpeed: 0.01, 
    orbitSpeed: 0.005,
    info: {
      diameter: '12,756 km',
      distanceFromSun: '149.6 million km',
      dayLength: '24 hours',
      yearLength: '365.25 days',
      moons: '1 (The Moon)',
      temperature: '15°C (average)',
      composition: 'Rocky with 71% water surface'
    }
  },
  { 
    name: 'Mars', 
    size: 0.12, 
    distance: 5, 
    color: '#C1440E', 
    rotationSpeed: 0.008, 
    orbitSpeed: 0.004,
    info: {
      diameter: '6,792 km',
      distanceFromSun: '227.9 million km',
      dayLength: '24.6 hours',
      yearLength: '687 Earth days',
      moons: '2 (Phobos, Deimos)',
      temperature: '-65°C (average)',
      composition: 'Rocky with iron oxide surface'
    }
  },
  { 
    name: 'Jupiter', 
    size: 0.5, 
    distance: 8, 
    color: '#D8CA9D', 
    rotationSpeed: 0.005, 
    orbitSpeed: 0.002,
    info: {
      diameter: '142,984 km',
      distanceFromSun: '778.5 million km',
      dayLength: '9.9 hours',
      yearLength: '12 Earth years',
      moons: '95+ known moons',
      temperature: '-110°C (cloud tops)',
      composition: 'Gas giant, mostly hydrogen and helium'
    }
  },
  { 
    name: 'Saturn', 
    size: 0.4, 
    distance: 11, 
    color: '#FAD5A5', 
    rotationSpeed: 0.004, 
    orbitSpeed: 0.0015,
    info: {
      diameter: '120,536 km',
      distanceFromSun: '1.43 billion km',
      dayLength: '10.7 hours',
      yearLength: '29 Earth years',
      moons: '146+ known moons',
      temperature: '-140°C (cloud tops)',
      composition: 'Gas giant with prominent ring system'
    }
  },
  { 
    name: 'Uranus', 
    size: 0.25, 
    distance: 14, 
    color: '#4FD0E7', 
    rotationSpeed: 0.003, 
    orbitSpeed: 0.001,
    info: {
      diameter: '51,118 km',
      distanceFromSun: '2.87 billion km',
      dayLength: '17.2 hours',
      yearLength: '84 Earth years',
      moons: '27 known moons',
      temperature: '-195°C (cloud tops)',
      composition: 'Ice giant with methane atmosphere'
    }
  },
  { 
    name: 'Neptune', 
    size: 0.24, 
    distance: 17, 
    color: '#4B70DD', 
    rotationSpeed: 0.002, 
    orbitSpeed: 0.0008,
    info: {
      diameter: '49,528 km',
      distanceFromSun: '4.50 billion km',
      dayLength: '16.1 hours',
      yearLength: '165 Earth years',
      moons: '16 known moons',
      temperature: '-200°C (cloud tops)',
      composition: 'Ice giant with strong winds'
    }
  }
];

export default planetData;
// This data structure can be used to render the planets in a 3D scene using Three.js or any other 3D library.
// Each planet object contains properties for size, distance from the sun, color, rotation speed, orbit speed, and additional information.